import React from 'react';
import { ValidationGroup } from '@bingads-webui-react/primitive-validation';
import { Constants } from '@bingads-webui-clientcenter/entity-utils';
import { TaxTypeFormPropTypes } from '../shapes';
import { LegalIdentifierHintI18nKey, LegalIdentifierNumberPilot } from '../constants';
import { registerTaxform } from '../taxform-store';
import { LegalIdentifierNumberField } from '../controls/legal-identitfier-number-field';
import { EmptyViewTaxForm } from './viewtaxforms/empty-viewtaxform';
import { withViewTaxFormWithFilledEmptyTaxValue, withTaxFormByPilot } from '../utils';
import { EmptyTaxForm } from './empty-taxform';

const { CountryCode, TaxType } = Constants;

const BhutanTaxSchema = {
  name: 'Bhutan Taxation Validation Schema',
  type: 'object',
  properties: {
    [TaxType.LegalIdentifier]: {
      type: 'string',
      required: true,
    },
  },
};

const BhutanTaxForm = ({
  i18n,
  data,
  onValidate,
  showLineByLineFormGroup,
  alwaysShowError,
}) => (
  <ValidationGroup
    validationProps={{
      i18n,
      onValidate,
      data,
      schema: BhutanTaxSchema,
    }}
  >
    <LegalIdentifierNumberField
      i18n={i18n}
      showLineByLineFormGroup={showLineByLineFormGroup}
      alwaysShowError={alwaysShowError}
      hintContent={i18n.getString(LegalIdentifierHintI18nKey[CountryCode.BT])}
    />
  </ValidationGroup>
);

BhutanTaxForm.propTypes = TaxTypeFormPropTypes;

const pilotFlag = LegalIdentifierNumberPilot;
const TaxForm = withTaxFormByPilot({ pilotFlag, PilotForm: BhutanTaxForm, DefaultForm: EmptyTaxForm });
const BhutanViewTaxForm = withViewTaxFormWithFilledEmptyTaxValue({ getTaxSchema: () => BhutanTaxSchema });
const ViewTaxForm = withTaxFormByPilot({ pilotFlag, PilotForm: BhutanViewTaxForm, DefaultForm: EmptyViewTaxForm });

registerTaxform('/BT/', TaxForm, ViewTaxForm);
